import { SVGProps } from 'react';

export const IconCheckCircle = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 84 84'>
      <path
        d='M42 0c23.197 0 42 18.803 42 42S65.197 84 42 84 0 65.197 0 42 18.803 0 42 0zm14.546 27.275L39.685 51.263 27.109 38.834l-4.218 4.268 14.258 14.09a4 4 0 006.085-.544l18.22-25.923-4.908-3.45z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  );
};
